import { useFirestore } from 'react-redux-firebase';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import collections from '../constants/FirestoreCollections';
import { actions } from '../actions';
import { NOBIS } from '../constants/organizations';

/**
 * Custom hook para agregar los chats asistidos y asignados al historial del usuario.
 *
 * @returns {Object} - An object containing the updateChatSupportAndAssignment function.
 */
export const useAssignSupportedChat = () => {
  const firestore = useFirestore();
  const appDispatch = useDispatch();
  const profile = useSelector((state) => state.firebase.profile);
  const organization = useSelector((state) => state.app.organization);
  const isNobis = NOBIS.includes(organization.id);
  const mySupportedChats = useSelector((state) => state.app.mySupportedChats);

  const updateChatSupportAndAssignment = useCallback(
    async ({ chatId, chat }) => {
      if (!profile || !chatId) return;

      try {
        const newChatHistory = { id: chatId, date: new Date(Date.now()) };

        const userRef = firestore.collection(collections.users).doc(profile.token.claims.user_id);
        const userDoc = await userRef.get();
        const existingChats = userDoc.data()?.supportedChats || [];
        const isChatAlreadyAdded = existingChats.some((e) => e.id.toString() === chatId.toString());

        if (!profile.supportedChats || !isChatAlreadyAdded) {
          await userRef.update({
            supportedChats: firestore.FieldValue.arrayUnion(newChatHistory),
          });

          appDispatch({
            type: actions.mySupportedChats,
            mySupportedChats: [...mySupportedChats, newChatHistory],
          });
        }

        if (!chat?.assigned && isNobis) {
          await firestore.collection(collections.chats).doc(chatId).update({
            assigned: profile.email,
          });
        }
      } catch (error) {
        console.error('updateChatSupportAndAssignment:', error);
      }
    },
    [mySupportedChats],
  );

  return { updateChatSupportAndAssignment };
};
